import api from './api';

export const getArticles = async () => {
  return await api.get('articles/learningCenter');
};

export const getArticleOfReferralLandingPage = async (articleId) => {
  return await api.get(`articles/${articleId}`)
}
